import { LitElement, html, css } from '@hh/global.js'

class HHCheckboxWrapper extends LitElement {
  static properties = {
    checked: {
      reflect: true,
    },
    disabled: {
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.checked = this.querySelector('input')?.checked
    this.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() == 'ENTER') {
        const inputElement = this.querySelector('input')
        if (this.querySelector('input')) {
          inputElement.checked = !inputElement.checked
          this.checked = inputElement.checked
        }
      }
    })
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  render() {
    return html`
      <div class="container ${this.disabled && 'disabled'}">
        <span class="checkmark"></span>
        <slot @change="${this.onChange}" name="input"></slot>
        <slot name="label"></slot>
      </div>
    `
  }

  static styles = css`
    :host {
      position: relative;
      display: inline-block;
    }

    .container {
      padding: var(--hh-spacing-2xs) 2px;
      display: inline-flex;
      align-items: center;
    }

    .disabled {
      pointer-events: none;
    }

    ::slotted(input) {
      width: var(--hh-width, 100%);
      height: var(--hh-height, 100%);
      position: absolute;
      top: 0;
      left: 0;
      border: none;
      appearance: none;
      padding: 0;
      margin: 0;
    }

    ::slotted(input:focus-visible) {
      outline-offset: 0 !important;
    }

    ::slotted(label) {
      position: relative;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      color: var(--hh-color-subdued);
    }

    :host([checked='true']) ::slotted(label),
    ::slotted(label:hover) {
      color: var(--hh-color-night);
    }

    .checkmark {
      -webkit-appearance: none;
      background-color: transparent;
      border: 0.1rem solid var(--hh-color-subdued);
      width: var(--hh-width, 12px);
      height: var(--hh-height, 12px);
      display: inline-block;
      position: relative;
      vertical-align: middle;
      cursor: pointer;
      margin-right: var(--hh-spacing-2xs);
      box-sizing: border-box !important;
    }

    @media screen and (min-width: 990px) {
      .checkmark {
        width: max(calc(16 / var(--screen-size) * 100vw), 1.6rem);
        height: max(calc(16 / var(--screen-size) * 100vw), 1.6rem);
        margin-right: max(calc(5 / var(--screen-size) * 100vw), 0.5rem);
      }
    }

    :host([checked='true']) .checkmark,
    .container:hover .checkmark {
      border-color: var(--hh-color-night);
    }

    :host([checked='true']) .checkmark:after {
      content: '';
      display: block;
      position: absolute;
      top: var(--hh-check-top, 0px);
      left: var(--hh-check-left, 3px);
      width: var(--hh-check-width, 3px);
      height: var(--hh-check-height, 6px);
      border: solid var(--hh-color, #000);
      border-width: 0 0.1rem 0.1rem 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    @media screen and (min-width: 990px) {
      :host([checked='true']) .checkmark:after {
        width: max(calc(3 / var(--screen-size) * 100vw), 0.4rem);
        height: max(calc(8 / var(--screen-size) * 100vw), 0.8rem);
        left: max(calc(5 / var(--screen-size) * 100vw), 0.5rem);
        top: 1px;
      }
    }

    .disabled ::slotted(label) {
      color: var(--hh-color-neutral);
    }

    .disabled .checkmark,
    .disabled .checkmark:after {
      border-color: var(--hh-color-neutral);
    }
  `
}

customElements.define('hh-checkbox-wrapper', HHCheckboxWrapper)
